import { useFeatureFlag } from '@fs/zion-flags'

/**
 * Whether the Name infoSheet renders its reworked group sections (FSS-15186).
 *
 * Deliberately the same flag as the Relationships card: this rework removes the per-group
 * "Add Person" button and the Edit Households path, and the Relationships card is what replaces
 * them. Shipping one without the other would leave no way into a group.
 *
 * @returns {boolean} Whether the reworked group sections render.
 */
const useGroupSectionsRework = () => {
  const relationshipsCardFlag = useFeatureFlag('rip_sharedImageViewer_relationshipsCard')

  return Boolean(relationshipsCardFlag?.isOn)
}

export default useGroupSectionsRework
